import { getBaseMetaTitle } from '@/environments'

const Awards = () => import('./Main')

const route = {
  path: '/awards',
  name: 'awards',
  meta: {
    title: `Awards - ${getBaseMetaTitle}`
  },
  component: Awards
}

export default route
